import React from 'react';
import { Link } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { Button } from '../components/ui/button';

const PaymentCancelled = () => {
  return (
    <div className="min-h-screen pt-24 pb-16 bg-[#0a0a0a] flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        <div className="text-center bg-[#121212] rounded-2xl border border-white/10 p-8">
          <div className="w-20 h-20 bg-red-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
            <XCircle className="w-12 h-12 text-red-500" />
          </div>
          <h1 className="text-3xl font-bold text-white mb-2">
            Pagamento annullato
          </h1>
          <p className="text-white/60 mb-6">
            Il pagamento è stato annullato. Nessun addebito è stato effettuato.
          </p>
          <p className="text-white/50 text-sm mb-6">
            Puoi tornare alla home e riprovare quando vuoi.
          </p>
          
          <div className="space-y-3">
            <Link to="/">
              <Button className="w-full py-6 text-lg font-bold bg-[#E91E63] hover:bg-[#C2185B] text-white rounded-full">
                Torna alla Home
              </Button>
            </Link>
            <Link to="/#prossime-date">
              <Button 
                variant="outline" 
                className="w-full py-6 text-lg font-medium border-white/20 text-white hover:bg-white/10 rounded-full"
              >
                Scegli un'altra data
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancelled;
